module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/dd575f1b468f022f6e32fec5576d5832.png";